import { SVGProps, Ref, forwardRef } from 'react';

export const EmployersRatingOutlinedSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 3.25a2.75 2.75 0 1 1-5.5 0 2.75 2.75 0 0 1 5.5 0m-1.4 0a1.35 1.35 0 1 1-2.7 0 1.35 1.35 0 0 1 2.7 0"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M9.5 9.5c0-.943 0-1.414.293-1.707S10.557 7.5 11.5 7.5H13c.943 0 1.414 0 1.707.293S15 8.557 15 9.5v6H1v-2c0-.943 0-1.414.293-1.707S2.057 11.5 3 11.5h2.25c0-.943 0-1.414.293-1.707S6.307 9.5 7.25 9.5zm4.108 2.93q-.007.836-.008 1.67h-2.7q-.001-.834-.008-1.67c-.009-1.173-.017-2.347.012-3.518v-.008h.008c.89-.022 1.786-.022 2.676 0h.008v.008c.03 1.171.02 2.345.012 3.518m-8.358.47q-.443 0-.884-.004c-.651-.004-1.303-.008-1.954.008h-.008v.008c-.007.29-.006.578-.005.868l.001.32h2.85zm4.25-2v3.2H6.65l.004-3.195h.008c.65-.017 1.303-.013 1.954-.009q.443.003.884.004"
                fill="currentColor"
            />
        </svg>
    )
);
EmployersRatingOutlinedSize16Glyph.displayName = 'EmployersRatingOutlinedSize16Glyph';
